import { useCallback } from 'react';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface UseToastReturn {
  show: (message: string, type?: ToastType) => void;
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
  warning: (message: string) => void;
}

// This will be provided by context from App.tsx
let toastCallback: ((message: string, type: ToastType) => void) | null = null;

export function setToastCallback(callback: (message: string, type: ToastType) => void) {
  toastCallback = callback;
}

export function useToast(): UseToastReturn {
  const show = useCallback((message: string, type: ToastType = 'info') => {
    if (toastCallback) {
      toastCallback(message, type);
    }
  }, []);

  return {
    show,
    success: (message: string) => show(message, 'success'),
    error: (message: string) => show(message, 'error'),
    info: (message: string) => show(message, 'info'),
    warning: (message: string) => show(message, 'warning'),
  };
}
